<template>
  <b-modal
    centered
    id="device-ass-mc"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Chọn thiết bị gán cho MC</h5>
      <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo">
      <div>
        <div class="form-group">
          <label>Mục đích sử dụng</label>
          <Select2
            v-model="typeUsage"
            :options="Config.typeUsage"
            placeholder="Chọn mục đích sử dụng"
          />
        </div>
        <div class="form-group">
          <label>Tên thiết bị</label>
          <Select2
            @change="getSerialDevice()"
            v-model="categoryId"
            :options="optionType"
            placeholder="Chọn tên thiết bị"
          />
        </div>
        <div class="form-group" v-if="this.optionSerial.length > 0">
          <label>Serial thiết bị</label>
          <Select2 v-model="idDevice" :options="optionSerial" placeholder="Chọn Serial thiết bị" />
        </div>
      </div>
    </form>
    <template #modal-footer>
      <b-button class="btn-style" size="sm" type="button" variant="light" @click="closeModal()">
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import { TicketService } from '@/services/ticket.service'
  export default {
    name: 'modal-device-ass-mc',
    props: {
      ticketId: {
        type: String,
      },
      closeModal: {
        type: Function,
      },
    },
    data() {
      return {
        Config,
        showLoading: false,
        idDevice: '',
        categoryId: '',
        typeUsage: '',
        optionType: [],
        optionInventory: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionSerial: [],
      }
    },
    created() {
      this.typeDeviceConfig()
      this.getListInventory()
    },
    methods: {
      async updateInfo() {
        try {
          this.showLoading = true
          const params = {
            typeUsage: this.typeUsage,
            ticketId: this.ticketId,
            idDevice: this.idDevice,
          }
          const data = await TicketService.chooseDeviceAssMC(params)
          if (data.code === 1000) {
            this.showSuccessMx('Chọn thiết bị gán cho MC thành công')
            this.$emit('updateInfoDeviceAssMC')
          } else this.showFailMx(data.message)
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListInventory() {
        try {
          const data = await DeviceService.infoWarehouse()
          if (data.success) {
            const body = data.data.map(e => {
              return {
                ...e,
                text: e.name,
              }
            })
            body.unshift({ id: '0', text: 'Tất cả', regions: [], level: '' })
            this.optionInventory = [...body]
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getSerialDevice() {
        try {
          this.showLoading = true
          this.optionInventory = this.optionInventory.filter(el => el.level === 'EMPLOYEE')
          const params = {
            inventoryIds: this.optionInventory.map(e => e.id),
            keeperId: this.dataUser.userId,
            typeUsage: this.typeUsage,
            categoryId: this.categoryId,
            limit: 100,
            page: 1,
          }
          const data = await DeviceService.listDevice(params)
          this.optionSerial = data.data.devices.map(e => {
            return {
              id: e.id,
              text: e.serial,
            }
          })
          console.log('data', this.optionSerial)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
</style>
